export default "__VITE_ASSET__khiTYq2J__"